import { api } from '../api/client';
import type { Pregnancy } from './types';

/** Gestação. `skipBarrier` em tudo: 403 aqui não é paywall, é dado da conta. */
export const pregnancyApi = {
  getById: (id: string) => api.get<Pregnancy | null>(`/api/pregnancies/${id}`, { skipBarrier: true }).catch(() => null),
  async listByUser(userId: string): Promise<Pregnancy[]> {
    const r = await api.get<Pregnancy[] | { items?: Pregnancy[] }>('/api/pregnancies', { params: { pregnantWomanId: userId }, skipBarrier: true }).catch(() => []);
    return Array.isArray(r) ? r : (r as any)?.items ?? [];
  },
  /** A gestação corrente da conta: pelo currentPregnancyId, senão a ativa (ou a primeira). */
  async getCurrent(user: { id: string; currentPregnancyId?: string | null }): Promise<Pregnancy | null> {
    if (user.currentPregnancyId) {
      const p = await pregnancyApi.getById(user.currentPregnancyId);
      if (p) return p;
    }
    const lista = await pregnancyApi.listByUser(user.id);
    return lista.find((p) => p.status === 'active') ?? lista[0] ?? null;
  },
  update: (id: string, data: Partial<Pregnancy>) => api.put<Pregnancy>(`/api/pregnancies/${id}`, data),
  patch: (id: string, data: Partial<Pregnancy>) => api.patch<Pregnancy>(`/api/pregnancies/${id}`, data),
};
